<template>
  <div class="account-not-exist">
    <IconSwitch :type="'qrcode'"></IconSwitch>
    <Icon></Icon>
    <Inputs :type="'accountnotexist'" v-on:inputText="getAccount" v-on:enterInput="enterInput"></Inputs>
    <Warn :type="'accountnotexist'"></Warn>
    <Buttons ref=btn :type="'signin'" :data="account"></Buttons>
  </div>
</template>

<script>
  import IconSwitch from '../components/Iconswitch'
  import Icon from '../components/Icon'
  import Inputs from '../components/Inputs'
  import Warn from '../components/Warn'
  import Buttons from '../components/Buttons'
  export default {
    data () {
      return {
        account: '' // 输入的账号
      }
    },
    components: {
      IconSwitch, Icon, Inputs, Warn, Buttons
    },
    methods: {
      // 输入框回车点击
      enterInput () {
        this.$refs.btn.clickBtn()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/css/_mixin.scss';
  .account-not-exist {
    @include white-bg;
    height: 420px;
    margin-top: -210px;
  }
</style>



// WEBPACK FOOTER //
// Accountnotexist.vue?a6cbaff4